import React from "react";
import { Helmet } from "react-helmet";

import AppComponent from "@app@::@component";

import PremiumComponent from "@route@::@premium:component";
import PremiumHook from "@route@::@premium:hook";

const Path = "/premium";
const Options = { caseSensitive: true };

const Premium: React.FC<PageProps> = ({ utils }) => {
    const { loading, data, refetch } = PremiumHook.Query();
    const update = PremiumHook.Mutation();

    if (loading) return <AppComponent.Loading />; // Return loading component if loading is active
    else if (!data) return utils.use.Navigate("/"); // Redirects to the home page if theirs no data

    return (
        <AppComponent.Animation.PageFade>
            <div className="page-body overflow-hidden">
                <Helmet children={<title>Titan-Bot – Premium</title>} />
                <AppComponent.Animation.ScreenCover />
                <AppComponent.Header utils={utils} path={Path} />
                <AppComponent.ProfileMenu utils={utils} profile={data.profile} path={Path} />
                <PremiumComponent.Section utils={utils} data={data} refetchData={refetch} update={update} />
                <AppComponent.Footer utils={utils} />
            </div>
        </AppComponent.Animation.PageFade>
    );
};

const Page = { Page: Premium, Path, Options };

export default Page;
